import React, { useCallback, useState } from "react";
import { useMutation} from "@apollo/client";
import {useAdminContext} from "../../contexts/AdminContext"
import ComboBoxMultiple from "./ComboBox";
import { ASSIGN_BOAT, DISMISS_BOAT} from "./queries";

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';


import { IoIosBoat } from "react-icons/io";
import { FaExchangeAlt, FaUser } from "react-icons/fa";


interface BoatAssignProp {
  userId: string;
  
}



const AssignBoatButton: React.FC<BoatAssignProp> = ({userId}) => {

  const [boatIds, setBoatIds] = useState<string[]>([]); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [open, setOpen] = useState(false);

  const {usersBoats, tabIdUsers, tabIdUser2Boat} = useAdminContext();

  const onAssignUserBoats = useCallback(() => {
      usersBoats.refetch();
  }, []);
  
  const [assignBoat] = useMutation(ASSIGN_BOAT);
  const [dissmissBoat] = useMutation(DISMISS_BOAT);

  const handleClose = () => setOpen(false);
  const handleShow = () => setOpen(true);

  const handleAssignBoat = async (e: React.FormEvent) => {
      e.preventDefault();
      setLoading(true);
      setShowSuccessMessage(false);
      setError(null);
  

      try {

        // On vérifie les ajouts et suppressions
        const adds: {user_id:string; bateau_id:string}[] = tabIdUser2Boat ? boatIds.filter(id => !tabIdUser2Boat[userId].includes(id)).map(boatId =>{
          return {
            user_id: userId,
            bateau_id: boatId
          };
        }): [];

        const deletes: {user_id:{ _eq: string }; bateau_id:{ _eq: string }}[] = tabIdUser2Boat ? tabIdUser2Boat[userId].filter(id => !boatIds.includes(id)).map(boatId =>{
          return {
            user_id: { _eq: userId },
            bateau_id: { _eq: boatId }
          };
        }): [];
        
        if(adds.length){
          const { data, errors } = await assignBoat({
            variables: {
              boats: adds
            },
          });
        }
        
        if(deletes.length){
          const { data, errors } = await dissmissBoat({
            variables: {
              boats: deletes
            },
          });
        }
        
        setLoading(false);
        setShowSuccessMessage(true);
  
        setTimeout(() => {
          setShowSuccessMessage(false);
          setOpen(false);
          onAssignUserBoats();
        }, 1000);
      } catch (err) {
        setLoading(false);
        setError(
          err instanceof Error ? err.message : "Une erreur inconnue est survenue"
        );
      }
  };


  return (
      <>
        <Button className="px-3 py-1 text-white" onClick={handleShow}>
            <div className="d-flex align-items-center justify-content-between">
                <FaUser/> <FaExchangeAlt/> <IoIosBoat/>
            </div>
        </Button>

        <Modal show={open} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Gestion des bateaux pour {tabIdUsers[userId]}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {error && (
                <p className="bg-red-100 text-red-600 p-3 rounded-lg mb-4 text-sm">
                  {error}
                </p>
              )}
              {showSuccessMessage && (
                <p className="bg-green-100 text-green-600 p-3 rounded-lg mb-4 text-sm">
                  Bateau(x) attribué(s) à {tabIdUsers[userId]} avec succès !
                </p>
              )}

              <Form onSubmit={handleAssignBoat} className="space-y-4">
                
                <ComboBoxMultiple {...{userId, setBoatIds}} ></ComboBoxMultiple>

                <Button
                  type="submit"
                  disabled={loading}
                  className="custom-gradient-btn w-100 fw-medium rounded text-white px-4 py-2"
                >
                  {loading ? "Assignation en cours..." : "Assigner bateau(x)"}
                </Button>
              </Form> 
            </Modal.Body>
        </Modal>
      </>
    );
};

export default AssignBoatButton;

